export const parseList = (s: string) => s.replace(/,[ ]*/, ', ');
